import moment from 'moment';

export function calculateTime(timer: number, shouldShowTimeInHHmmFormat = false): string {
  if (timer === undefined) return '-';
  if (timer <= 0) return shouldShowTimeInHHmmFormat ? '00:00' : '0h 0m';
  let formattedTimer = '';
  const duration = moment.duration(timer);
  if (!shouldShowTimeInHHmmFormat) {
    formattedTimer = duration.asHours() + 'h ' + duration.minutes() + 'm';
  } else {
    formattedTimer =
      Math.floor(duration.asHours())
        .toString()
        .padStart(2, '0') +
      ':' +
      duration
        .minutes()
        .toString()
        .padStart(2, '0');
  }

  return formattedTimer;
}

export function getTimerPercentage(current: number, ceiling: number): number {
  let time = ceiling - current;
  time = time < 0 ? 0 : time;
  // If time left is less than a minute, return 0
  if (time < 60000) return 0;
  const pv = (time / ceiling) * 100;
  return pv > 0 && pv < 1 ? 1 : Math.floor(pv);
}
